<template>
  <div class="page-wrapper">
    <router-view :key="$route.name" />
    <PersonalBar />
  </div>
</template>

<script>
import PersonalBar from '@/components/facilitator/PersonalBar.vue';

export default {
  components: {
    PersonalBar,
  },
};
</script>

<style scoped>
.page-wrapper {
  width: 100%;
  height: 100%;
}
</style>
